import React from "react";
import "./App.css";
import Player from "./components/Player";
import videojs from "video.js";
import "video.js/dist/video-js.css";

function App() {
  const playerRef = React.useRef(null);

  const videoJsOptions = {
    autoplay: true,
    controls: true,
    responsive: true,
    fluid: true,
    sources: [
      {
        src: "/output.mp4",
        type: "video/mp4",
      },
    ],
  };

  const handlePlayerReady = (player) => {
    playerRef.current = player;

    // You can handle player events here, for example:
    player.on("waiting", () => {
      videojs.log("player is waiting");
    });

    player.on("dispose", () => {
      videojs.log("player will dispose");
    });
  };
  return (
    <div className="App">
      <header className="App-header">
        <Player
          className="Player-container"
          options={videoJsOptions}
          onReady={handlePlayerReady}
        />
      </header>
    </div>
  );
}

export default App;
